import { Injectable, Type } from '@angular/core';
import {
    AutocompleteInputType,
    CheckBoxInputType,
    ChipListInputType,
    DateInputType,
    DateRangeInputType,
    InputType,
    InputDiscriminators,
    QuestionDefinition,
    RichTextInputType,
    SelectInputType,
    TextAreaInputType,
    TextInputType,
    TextInputViewType,
    DateTimeInputType
} from '../form.types';

@Injectable({
    providedIn: 'root'
})
export class QuestionService {
    constructor() {}

    isText(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'TEXT';
    }

    toText(obj: InputType): TextInputType {
        obj.discriminator = 'TEXT';
        return obj as TextInputType;
    }

    toTextView(obj: InputType): TextInputViewType {
        obj.discriminator = 'TEXT-VIEW';
        return obj as TextInputViewType;
    }

    toChipList(obj: InputType): ChipListInputType {
        obj.discriminator = 'CHIP-LIST';
        return obj as ChipListInputType;
    }

    isChipList(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'CHIP-LIST';
    }

    toCheckBox(obj: InputType): CheckBoxInputType {
        obj.discriminator = 'CHECKBOX';
        return obj as CheckBoxInputType;
    }

    isCheckBox(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'CHECKBOX';
    }

    toAutoComplete(obj: InputType): AutocompleteInputType {
        obj.discriminator = 'AUTOCOMPLETE';
        return obj as AutocompleteInputType;
    }

    isAutocomplete(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'AUTOCOMPLETE';
    }

    toTextArea(obj: InputType): TextAreaInputType {
        obj.discriminator = 'TEXTAREA';
        return obj as TextAreaInputType;
    }

    isTextArea(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'TEXTAREA';
    }

    toRichText(obj: InputType): RichTextInputType {
        obj.discriminator = 'RICH-TEXT';
        return obj as RichTextInputType;
    }

    isRichText(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'RICH-TEXT';
    }

    toSelect(obj: InputType): SelectInputType {
        obj.discriminator = 'SELECT';
        return obj as SelectInputType;
    }

    isSelect(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'SELECT';
    }

    toDate(obj: InputType): DateInputType {
        obj.discriminator = 'DATE';
        return obj as DateInputType;
    }

    isDate(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'DATE';
    }

    toDateTime(obj: InputType): DateTimeInputType {
        obj.discriminator = 'DATE-TIME';
        return obj as DateTimeInputType;
    }

    toDateRange(obj: InputType): DateRangeInputType {
        obj.discriminator = 'DATE-RANGE';
        return obj as DateRangeInputType;
    }

    isDateRange(question: QuestionDefinition): boolean {
        return question && question?.input?.discriminator === 'DATE-RANGE';
    }
}
